export default __webpack_public_path__ + "static/SharpSans-Medium-def47df9836c7d0ad8e2c212975db5a3.otf";